module.exports = __webpack_public_path__ + "img/IMG_4945.be22aee8.jpg";